import { args_type } from './interfaces';

// 注意事項：
// 1. 只能用 ES6 以下語法 (不能使用 async, await, spread operator(...))

// declare const get_db: get_db_type;
declare const self: { db_version: { [key: string]: number }; db_disabled: boolean };
declare const http_request_func: (args: args_type) => void;

// Web Worker 主函數部分
// 所有變數只能在這裡面宣告
// 匯入任何程式碼需用 importScripts，無法用 import

export default function httpWorker(_args: any): void {
  try {
    // @ts-ignore
    importScripts('core-js/es/promise');
  } catch (err) {}

  // 宣告接收到訊息時要做的事
  onmessage = (event: MessageEvent): void => {
    // ███╗   ███╗ █████╗ ██╗███╗   ██╗
    // ████╗ ████║██╔══██╗██║████╗  ██║
    // ██╔████╔██║███████║██║██╔██╗ ██║
    // ██║╚██╔╝██║██╔══██║██║██║╚██╗██║
    // ██║ ╚═╝ ██║██║  ██║██║██║ ╚████║
    // ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
    // 主             程             式
    const args: args_type = JSON.parse(event.data);
    self.db_version = {};
    self.db_disabled = false;
    http_request_func(args);
  };
}
